function getMetaData(key) {

    let metaDataValue;

    // v3
    metaDataValue = window.PageManager && PageManager.PageMetaData && PageManager.PageMetaData.Values && PageManager.PageMetaData.Values[key] ? PageManager.PageMetaData.Values[key] : null;

    // v4
    if (metaDataValue === null) {

        let v4meta = document.head.querySelector('meta[property="' + key + '"], meta[name="' + key + '"], meta[property="PageMetadata:' + key + '"], meta[name="' + key.toLowerCase() + '"], meta[property="PageMetadata:' + key.toLowerCase() + '"], meta[property="' + key.toLowerCase() + '"]');

        if (v4meta) {

            metaDataValue = decodeURI(v4meta.content.replace('%', '%25'));
        }
    }

    return metaDataValue;

}

export function setMetaData(key, value) {
    // Check if the element is set

    if (getMetaData(key)) {

        let meta = document.head.querySelector('meta[name="' + key + '"], meta[property="' + key + '"], meta[property="PageMetadata:' + key + '"], meta[name="' + key.toLowerCase() + '"], meta[property="PageMetadata:' + key.toLowerCase() + '"], meta[property="' + key.toLowerCase() + '"]');

        if (meta) {

            meta.content = value;
        }

        if (window.PageManager && PageManager.PageMetaData && PageManager.PageMetaData.Values && PageManager.PageMetaData.Values[key]) {

            PageManager.PageMetaData.Values[key] = value;
        }

    } else {

        // If not set create
        let tmp = document.createElement("div");

        tmp.innerHTML = '<meta property="PageMetadata:' + key + '" content="' + encodeURI(value) + '" />';

        let childNodes = [].slice.call(tmp.childNodes);

        childNodes.forEach(function (ce) {
            document.head.appendChild(ce);
        });

        if (window.PageManager && PageManager.PageMetaData && PageManager.PageMetaData.Values && PageManager.PageMetaData.Values) {

            window.PageManager.PageMetaData.Values[key] = value;
        }
    }
}

function removeMetaData(key) {

    // Check if the element is set
    if (getMetaData(key)) {

        let meta = document.head.querySelector('meta[name="' + key + '"], meta[property="' + key + '"]');
        if (meta) {
            document.head.removeChild(meta);
        }

        if (window.PageManager && PageManager.PageMetaData && PageManager.PageMetaData.Values) {
            PageManager.PageMetaData.Remove(key.replace('PageMetadata:', ''));
        }
    }
}

export default {getMetaData, setMetaData, removeMetaData};
